import { Container, Grid, Typography, Box, Tooltip } from "@mui/material";
import React from "react";
import { NavLink, Route, Routes } from "react-router-dom";
import classes from "../Styles/about.module.css";
import CodeIcon from "@mui/icons-material/Code";
import LightbulbIcon from "@mui/icons-material/Lightbulb";
import VideogameAssetIcon from "@mui/icons-material/VideogameAsset";
import CloseIcon from "@mui/icons-material/Close";
import Info from "../Components/Info";
import ProfessionalInfo from "../Components/ProfessionalInfo";
import Hobbies from "../Components/Hobbies";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { Carousel } from "react-responsive-carousel";
import s1 from "../Assets/s1.png";
import s2 from "../Assets/s2.png";
import s3 from "../Assets/s3.png";
import s4 from "../Assets/s4.png";
import s5 from "../Assets/s5.png";
import s6 from "../Assets/s6.png";

const AboutMe = () => {
  return (
    <>
      <Container disableGutters maxWidth="xl" className={classes.about_body}>
        <Grid container className={classes.grid_container}>
          <Grid
            item
            xs={12}
            sx={{
              display: { xs: "block", md: "none" },
              pl: { xs: 3, md: 0 },
              pb: { xs: 3, md: 0 },
              pt: 3,
              textAlign: "center",
            }}
          >
            <Typography className={classes.about_text}>_about-me</Typography>
          </Grid>
          <Grid
            item
            className={classes.grid_item}
            sx={{ display: { xs: "none", md: "block" } }}
            md={0.6}
          >
            <NavLink
              style={({ isActive }) =>
                isActive ? { color: "#81A1C1" } : { color: "#607B96" }
              }
              to={`/aboutme/professional-information`}
            >
              <Tooltip title="professional-info" placement="right-start">
                <Typography sx={{ pb: 2 }}>
                  <CodeIcon />
                </Typography>
              </Tooltip>
            </NavLink>
            <NavLink
              style={({ isActive }) =>
                isActive ? { color: "#81A1C1" } : { color: "#607B96" }
              }
              to={`/aboutme/personal-information`}
            >
              <Tooltip title="personal-info" placement="right-start">
                <Typography sx={{ pb: 2 }}>
                  <LightbulbIcon />
                </Typography>
              </Tooltip>
            </NavLink>
            <NavLink
              style={({ isActive }) =>
                isActive ? { color: "#81A1C1" } : { color: "#607B96" }
              }
              to={`/aboutme/hobbies`}
            >
              <Tooltip title="hobbies" placement="right-start">
                <Typography sx={{ pb: 2 }}>
                  <VideogameAssetIcon />
                </Typography>
              </Tooltip>
            </NavLink>
          </Grid>

          <Routes>
            <Route exact path="/" element={<ProfessionalInfo />} />
            <Route
              exact
              path="professional-information"
              element={<ProfessionalInfo />}
            />
            <Route exact path="hobbies" element={<Hobbies />} />
          </Routes>
          <Grid
            item
            md={5}
            sx={{ borderRight: { xs: "none", md: "0.25px solid #1E2D3D" } }}
          >
            <Box
              sx={{
                overflowY: { xs: "visible", md: "scroll" },
                height: "100%",
              }}
              className={classes.about_overflow}
            >
              <Box
                sx={{
                  borderBottom: { xs: "none", md: "0.25px solid #1E2D3D" },
                }}
              >
                <Box sx={{ display: "flex" }}>
                  <Typography
                    sx={{
                      color: "#607B96",
                      borderRight: "0.25px solid #1E2D3D",
                      fontSize: "16px",
                      display: { xs: "none", md: "block" },
                      fontFamily: "'Fira Code', monospace !important",
                      pt: 1.4,
                      pb: 1,
                      pl: 2,
                    }}
                  >
                    personal-info
                    <CloseIcon
                      sx={{ fontSize: "18px", pt: 0.4, pl: 4, pr: 2 }}
                    />
                  </Typography>
                  <Typography
                    sx={{
                      color: "#FFFFFF",

                      fontSize: "16px",
                      display: { xs: "block", md: "none" },
                      fontFamily: "'Fira Code', monospace !important",
                      pt: 5,
                      pb: 1,
                      pl: 2,
                    }}
                  >
                    {`// personal-info`}
                  </Typography>
                </Box>
              </Box>
              <Box sx={{ display: { xs: "none", md: "block" }, p: 2 }}>
                <Info text={" /**"} number={1} />
                <Info text={"  * About Me"} number={2} />
                <Info text={" * I am a coding enthusiast."} number={3} />
                <Info
                  text={" * The Tech world has really changed my"}
                  number={4}
                />
                <Info
                  text={" * perspective about different things,"}
                  number={5}
                />
                <Info
                  text={" * it has helped me identify things i did"}
                  number={6}
                />
                <Info text={" * not even know I had"} number={5} />
                <Info
                  text={" * I am a friendly person. I love working with teams "}
                  number={7}
                />

                <Info
                  text={" * of the same vision  or goals as me. I am always"}
                  number={8}
                />
                <Info
                  text={
                    " * eager to learn new things.I find the most passion in"
                  }
                  number={9}
                />
                <Info
                  text={
                    " * web designing. I have three years working experience"
                  }
                  number={10}
                />
                <Info text={" * .I am fully proficient in"} number={11} />
                <Info
                  text={
                    " * HTML, CSS, Javascript, React.js, Bootstrap, MUI, GraphQL,"
                  }
                  number={12}
                />
                <Info
                  text={" * React-Query, React hooks, web components, ES6"}
                  number={13}
                />
                <Info text={" * .I am currently learning"} number={15} />
                <Info
                  text={" * Python Django,Node (Express) Angular"}
                  number={14}
                />
                <Info text={" * .Interest in"} number={15} />
                <Info text={" * Web3, Solidity"} number={16} />
                <Info text={" **/"} number={17} />
              </Box>
              <Box sx={{ display: { xs: "block", md: "block" }, pt: 4, pb: 5 }}>
                <Typography className={classes.about_info_small}>
                  I'm am a Frontend engineer with diverse experience in web
                  solution development. I have worked on different web solutions
                  ranging from Human resource management solutions (HRMS),
                  Remote Monitoring Solution(RMS), Learning Management
                  Solution(LMS), Attendances Solution and few more. I’m
                  passionate about writing scalable and clean code that why I
                  invest more in learning and seeking new opportunities.
                </Typography>
              </Box>
            </Box>
          </Grid>
          <Grid item md={4}>
            <Typography
              sx={{
                color: "#FFFFFF",

                fontSize: "16px",

                fontFamily: "'Fira Code', monospace !important",
                pt: 2,
                pb: 1,
                pl: 2,
              }}
            >
              {`// Certifications`}
            </Typography>
            <Box
              sx={{
                width: "100%",
                mt: 10,
              }}
            >
              <Carousel
                autoPlay={true}
                centerSlidePercentage={20}
                infiniteLoop={true}
                interval={3000}
                stopOnHover={true}
                swipeable={true}
                width="100%"
                transitionTime={2000}
                showIndicators={false}
                showThumbs={false}
              >
                <div>
                  <img
                    style={{ width: "100%", height: "300px" }}
                    src={s1}
                    alt="certificate"
                  />
                </div>
                <div>
                  <img
                    style={{ width: "100%", height: "300px" }}
                    src={s2}
                    alt="certificate"
                  />
                </div>
                <div>
                  <img
                    style={{ width: "100%", height: "300px" }}
                    src={s3}
                    alt="certificate"
                  />
                </div>
                <div>
                  <img
                    style={{ width: "100%", height: "300px" }}
                    src={s4}
                    alt="certificate"
                  />
                </div>
                <div>
                  <img
                    style={{ width: "100%", height: "300px" }}
                    src={s5}
                    alt="certificate"
                  />
                </div>
                <div>
                  <img
                    style={{ width: "100%", height: "300px" }}
                    src={s6}
                    alt="certificate"
                  />
                </div>
              </Carousel>
            </Box>
          </Grid>
        </Grid>
      </Container>
    </>
  );
};

export default AboutMe;
